import React, { useState, useEffect } from 'react';
import '../../../entrydoor.css';
import { formatToDecimal } from '../../conversions';
import { formatToFractional } from '../../conversions';

const FrameHeight = ({ value, onChange, 
                       id = 'FrameHeight', label = 'Frame Height', doorSizeValue, doorHeightValue, passSelectedDoor, 
                       minValue, maxValue,
                       disabled = false  }) => {
    const [selectedFrameHeight, setSelectedFrameHeight] = useState(value || "80\"");
    const [FrameHeightError, setFrameHeightError] = useState("");

    const calcHeight = (doorType, doorHeight) => {
        if (doorHeight === '6\'8"' || doorHeight === '6\'8') {
            return '82 3/8"';
        }
        if (doorHeight === '7"' || doorHeight === '7') {
            return '87 3/8"';
        }
        if (doorHeight === '8"' || doorHeight === '8') {
            return '98 3/8"';
        }
        return 0;
     }

    useEffect(() => {
        // Re-validate the current input whenever min/max values change
        if (selectedFrameHeight && minValue && maxValue) {
          validateFrameHeight(selectedFrameHeight);
        }
      }, [minValue, maxValue]);

    // Follow value changes made by the parent (e.g. typed in a linked mm field)
    useEffect(() => {
        if (value !== undefined && value !== selectedFrameHeight) {
          setSelectedFrameHeight(value);
          validateFrameHeight(value);
        }
    }, [value]);

    const handleFrameHeightChange = (e) => {
        setSelectedFrameHeight(e.target.value);
        validateFrameHeight(e.target.value);
        onChange(e.target.value);
    };

    const validateFrameHeight = (val) => {
        const numericValue = formatToDecimal(val);
        if (numericValue && (numericValue < minValue || numericValue > maxValue)) {
            setFrameHeightError(`Height must be between ${minValue} and ${maxValue}`);
        } else {
            setFrameHeightError('');
        }
      };
    const handleFocus = (e) => {
      let decimalValue = formatToDecimal(e.target.value);
      if (decimalValue === null) decimalValue = "";
      setSelectedFrameHeight(decimalValue);
    };

    const handleBlur = (e) => {
      const fractionalValue = formatToFractional(e.target.value);
      setSelectedFrameHeight(fractionalValue);
      onChange(fractionalValue);
    };

    return (
        <div className="a-container">
            <label disabled={disabled} htmlFor={id}>{label}</label>
            <input
                disabled={disabled}
                id={id}
                value={selectedFrameHeight}
                onChange={handleFrameHeightChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
            >
            </input>
            {FrameHeightError && <p className="error">{FrameHeightError}</p>}
        </div>
    );
};

export default FrameHeight;
